import React from 'react';

const MentionsLegales: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-prudens-bleu-fonce to-gray-100 py-16 text-white">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Mentions légales
          </h1>
          <p className="text-lg md:text-xl text-prudens-bleu-grise max-w-3xl">
            Informations légales de la société PRUDENS et de l'hébergement du site.
          </p>
        </div>
      </section>

      {/* Contenu principal */}
      <section className="py-12 bg-gray-100">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8">
            <h2 className="text-2xl font-bold text-prudens-bleu-fonce mb-6">
              Mentions légales
            </h2>

            <div className="space-y-8 text-gray-700 text-sm md:text-base leading-relaxed">
              {/* 1. Éditeur du site */}
              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  1. Éditeur du site
                </h3>
                <p className="mb-3">
                  Le présent site web est édité par la société <span className="font-semibold">PRUDENS</span> :
                </p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Forme juridique : SAS (Société par actions simplifiée)</li>
                  <li>Capital social : 2 000,00 €</li>
                  <li>Siège social : 87 rue Saint Aubert, 62000 ARRAS</li>
                  <li>SIREN : 933 600 504</li>
                  <li>SIRET : 933 600 504 00015</li>
                  <li>Numéro de TVA intracommunautaire : FR50 933 600 504</li>
                  <li>
                    Code APE : 88.10B (Accueil ou accompagnement sans hébergement d'adultes handicapés ou de personnes âgées)
                  </li>
                  <li>Directeur de la publication : Vincent Husson</li>
                  <li>
                    Contact :{' '}
                    <a
                      href="mailto:contact@prudens-france.fr"
                      className="text-prudens-bleu-clair hover:text-prudens-bleu-fonce underline-offset-2 hover:underline"
                    >
                      contact@prudens-france.fr
                    </a>{' '}
                    | +33 6 26 86 20 99
                  </li>
                </ul>
              </section>

              {/* 2. Hébergeur du site */}
              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  2. Hébergeur du site
                </h3>
                <p className="mb-2">Le site est hébergé par la société Hostinger :</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Raison sociale : Hostinger International Ltd.</li>
                  <li>Adresse : 61 Lordou Vironos Street, 6023 Larnaca, Chypre</li>
                  <li>
                    Site web :{' '}
                    <a
                      href="https://www.hostinger.fr"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-prudens-bleu-clair hover:text-prudens-bleu-fonce underline-offset-2 hover:underline"
                    >
                      www.hostinger.fr
                    </a>
                  </li>
                </ul>
              </section>

              {/* 3. Propriété intellectuelle */}
              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  3. Propriété intellectuelle
                </h3>
                <p>
                L’ensemble des éléments constituant ce site (structure, textes, logos) est la propriété exclusive de la société PRUDENS.

Les illustrations et visuels présents sur le site ont été générés via des outils d'intelligence artificielle (DALL-E et Gemini). Conformément aux conditions d'utilisation de ces services, la société PRUDENS dispose des droits d'exploitation commerciale de ces contenus.

Toute reproduction, représentation ou diffusion, en tout ou partie, du contenu de ce site sur quelque support que ce soit est interdite, sauf autorisation expresse de l'éditeur.
                </p>
              </section>

              {/* 4. Protection des données personnelles */}
              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  4. Protection des données personnelles
                </h3>
                <p className="mb-3">
                  Ce site est un site vitrine ne comportant pas de formulaire de collecte de données.
                </p>
                <p className="mb-3">
                  <span className="font-semibold">Données de contact :</span> Les informations envoyées par l'utilisateur
                  via e-mail ou téléphone sont utilisées exclusivement par PRUDENS pour répondre aux demandes de
                  renseignements. Elles ne sont ni vendues, ni cédées à des tiers.
                </p>
                <p className="mb-3">
                  <span className="font-semibold">Droits des utilisateurs :</span> Conformément au RGPD, vous disposez d'un
                  droit d'accès, de rectification et de suppression de vos données personnelles sur simple demande à
                  l'adresse :{' '}
                  <a
                    href="mailto:contact@prudens-france.fr"
                    className="text-prudens-bleu-clair hover:text-prudens-bleu-fonce underline-offset-2 hover:underline"
                  >
                    contact@prudens-france.fr
                  </a>
                  .
                </p>
                <p>
                  Les photos des membres de l'équipe présentes sur le site sont publiées avec le consentement exprès des
                  personnes concernées. Conformément au RGPD, chaque collaborateur dispose d'un droit de retrait de son image
                  sur simple demande.
                </p>
              </section>

              {/* 5. Cookies */}
              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  5. Cookies
                </h3>
                <p>
                  Le site n'utilise aucun cookie de traçage, de publicité ou de mesure d'audience nécessitant le consentement
                  préalable des utilisateurs.
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegales;

